export default "__VITE_ASSET__D4QW1GyF__"